import React from 'react';

const ChatCart = (props) => {
    return (
        <div onClick={props.onClick} style={{ cursor: 'pointer', width: '100%', minHeight: 179, background: '#FFF', borderRadius: 2, border: '1px solid #DDD', boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.10)', padding: 16, boxSizing: 'border-box', overflow: 'hidden' }}>
            <div style={{ fontSize: 16, color: '#000' }}>
                {props.title}
            </div>
            <div style={{ marginTop: 16 }}>
                {props?.children}
            </div>
        </div>
    );
}

export default ChatCart;